<template>
  <div>
    <b-dropdown-header class="text-center text-lg-left justify-content-center">
      <strong v-dynamic-content:dropdown_yourinformation></strong>
    </b-dropdown-header>
    <b-dropdown-item v-if="contact.address" class="justify-content-center text-center">
      <div class="dropdown_profile d-inline-block text-left">
        <div>{{ fullName }}</div>
        <small v-if="contact.address">{{ streetAndHouseNumber }}</small>
        <small v-if="contact.address">{{ contact.address.postalCode }} {{ contact.address.city }}</small>
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="iquote.energyConsumption"
      class="justify-content-center text-center text-lg-left w-100"
    >
      <div class="dropdown_energy d-inline-block text-left">
        <div v-dynamic-content:dropdown_usage="[iquote.energyConsumption]"></div>
      </div>
    </b-dropdown-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PersonalInformation',
  computed: {
    ...mapGetters(['fullName', 'streetAndHouseNumber'])
  }
}
</script>
